// import 'bootstrap/dist/css/bootstrap.css';

import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';

import { store } from './_redux/store';
import { App } from './App';
// import registerServiceWorker from './registerServiceWorker';
import CacheBuster from './_helpers/cacheBuster';
import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfigs } from './_helpers/authConfig';
import { MsalProvider } from '@azure/msal-react';
import { ThemeProvider } from '@material-ui/core';
import './asset/theme/main.scss'
import { Themes } from './asset/theme/app-theme';

export const msalInstance = new PublicClientApplication(msalConfigs)

render(
    <Provider store={store}>
        <CacheBuster>
            <MsalProvider instance={msalInstance}>
                <ThemeProvider theme={Themes.AppTheme}>
                    <App />
                </ThemeProvider>
            </MsalProvider>
        </CacheBuster>
    </Provider>,
    document.getElementById('root')
);

// registerServiceWorker();
